export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#ffffff",
    hexDark: "#0a0a0a",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "#fafafa",
    hexDark: "#171717",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "#e5e5e5",
    hexDark: "#262626",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "#404040",
    hexDark: "#d4d4d4",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "#0a0a0a",
    hexDark: "#fafafa",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "#737373",
    hexDark: "#a3a3a3",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "oklch(58.6% 0.253 17.585)",
    hexDark: "oklch(71.2% 0.194 13.428)",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "oklch(96.9% 0.015 12.422)",
    hexDark: "oklch(25% 0.06 15)",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "oklch(51.4% 0.222 16.935)",
    hexDark: "oklch(81% 0.16 14)",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "oklch(82.8% 0.189 84.429)",
    hexDark: "oklch(82.8% 0.189 84.429)",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "oklch(96.2% 0.059 95.617)",
    hexDark: "oklch(26% 0.05 85)",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "oklch(66.6% 0.179 58.318)",
    hexDark: "oklch(87.9% 0.169 91.605)",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "oklch(64.6% 0.222 41.116)",
    hexDark: "oklch(70.5% 0.213 47.604)",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "oklch(98% 0.016 73.684)",
    hexDark: "oklch(25% 0.06 45)",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "oklch(55.3% 0.195 38.402)",
    hexDark: "oklch(75% 0.183 55.934)",
  },
];

export const FONTS = {
  display: "Stack Sans Text",
  body: "DM Sans",
};
